export const getBookingkitDateUrl = (dateId: string) => {
  return `https://eu5.bookingkit.de/eventDate/view/${dateId}`;
};
